import styles from './Button.module.scss';

export default function ButtonComponent(props) {
    const stylesDisabled = props.disabled ? styles[`redl-btn-disabled`] : null;
    const classNames = styles[`redl-btn-${props.variant}`] + ' ' + styles[`redl-btn-${props.size}`] + ' ' + stylesDisabled;

    return (
        <button className={classNames} {...props} type={props.type || 'button'}>
            {props.children}
        </button>
    );
}